export default __webpack_public_path__ + "static/water-cb3b772ccb37599f1e80c294395c0b2a.mp4";